<template>
    <div class="contentCenter">
        <div v-for="(item, index) in markList" :key="index" class="contentCenter wrapper">
            <h4>{{ item.title }}</h4>
            <div :style="item.imgWidth">
                <img :src="item.imgUrl" alt="certification mark">
            </div>
            <p v-html="item.content" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        markList: {
            type: Array,
            require: true,
            default: () => [],
        },
    },
};
</script>

<style lang="sass" scoped>
.wrapper
    padding: 12px
    border: 3px solid rgb(0, 128, 128)
    border-radius: 10px
    h4
        font-weight: 700
        font-size: 14px
    p
        font-size: 14px
        font-weight: normal
    img
        width: 100%
        height: 100%
</style>
